import { Truck, Bike, Zap, Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

const pillars = [
  {
    icon: Truck,
    title: "Livraison à votre hébergement",
    tooltip: "On livre directement à votre camping, gîte ou hôtel. Zéro déplacement, zéro stress.",
  },
  {
    icon: Bike,
    title: "Flotte récente & contrôlée",
    tooltip: "Chaque vélo est vérifié avant location. Du matériel de qualité, toujours prêt à rouler.",
  },
  {
    icon: Zap,
    title: "Assistance express",
    tooltip: "Un souci pendant la balade ? Notre équipe locale intervient rapidement pour vous dépanner.",
  },
];

const AdvantagesSection = () => {
  return (
    <section className="border-b border-border bg-card">
      <div className="container-narrow">
        <TooltipProvider delayDuration={200}>
          <div className="flex flex-col sm:flex-row items-center justify-center sm:justify-around gap-4 sm:gap-6 py-5">
            {pillars.map((pillar, i) => (
              <Tooltip key={i}>
                <TooltipTrigger asChild>
                  <div className="flex items-center gap-3 cursor-help">
                    <pillar.icon className="w-6 h-6 text-foreground shrink-0" />
                    <span className="text-sm font-semibold text-foreground">
                      {pillar.title}
                    </span>
                    <Info className="w-3.5 h-3.5 text-muted-foreground" />
                  </div>
                </TooltipTrigger>
                <TooltipContent>
                  <p className="max-w-[220px] text-center">{pillar.tooltip}</p>
                </TooltipContent>
              </Tooltip>
            ))}
          </div>
        </TooltipProvider>
      </div>
    </section>
  );
};

export default AdvantagesSection;
